module.exports = __webpack_public_path__ + "static/media/John.47774762.jpg";